/** Resolve WebSocket base URL for the Poppycock Worker. */
export function getWsBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_WS_URL as string | undefined;
  if (fromEnv && fromEnv.trim()) {
    return fromEnv.replace(/\/$/, "");
  }

  // Local default — Wrangler dev
  if (typeof window !== "undefined") {
    const { protocol, hostname } = window.location;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return "ws://127.0.0.1:8787";
    }
    // Same host over wss when co-hosted (unlikely) — prefer env in prod
    const wsProto = protocol === "https:" ? "wss:" : "ws:";
    return `${wsProto}//${hostname}`;
  }

  return "ws://127.0.0.1:8787";
}

export function buildRoomWsUrl(code?: string): string {
  const base = getWsBaseUrl();
  const url = new URL(`${base}/ws`);
  if (code && code !== "new") {
    url.searchParams.set("code", code.toUpperCase());
  } else {
    url.searchParams.set("code", "new");
  }
  return url.toString();
}
